import { Collapsible } from "./collapsible";
import { Content } from "./content/content";
import { Header } from "./header/header";
import { Item } from "./item/item";
import { ItemContent } from "./item/item-content";
import { ItemIcon } from "./item/item-icon";
import { Root } from "./root/root";
import { Scrollable } from "./scrollable/scrollable";
import { Subtitle } from "./subtitle/subtitle";

const ItemWithSubComponents = Item as typeof Item & {
    Content: typeof ItemContent;
    Icon: typeof ItemIcon;
};

const Sidebar = Root as typeof Root & {
    Scrollable: typeof Scrollable;
    Content: typeof Content;
    Item: typeof ItemWithSubComponents;
    Subtitle: typeof Subtitle;
    Header: typeof Header;
    Collapsible: typeof Collapsible;
};

ItemWithSubComponents.Content = ItemContent;
ItemWithSubComponents.Icon = ItemIcon;

Sidebar.Scrollable = Scrollable;
Sidebar.Content = Content;
Sidebar.Item = ItemWithSubComponents;
Sidebar.Subtitle = Subtitle;
Sidebar.Header = Header;
Sidebar.Collapsible = Collapsible;

export { Sidebar };
export type { RootProps as SidebarProps } from "./root/root";
export type { ScrollableProps } from "./scrollable/scrollable";
export type { ContentProps } from "./content/content";
export type { ItemProps } from "./item/item";
export type { ItemIconProps } from "./item/item-icon";
export type { ItemContentProps } from "./item/item-content";
export type { SubtitleProps } from "./subtitle/subtitle";
export type { HeaderProps } from "./header/header";
export type { CollapsibleProps } from "./collapsible/collapsible";
export { useCollapsible } from "./collapsible/useCollapsible";
